<template>
  <div>
    <router-view></router-view>

    <a
        class="scrollToTopLink"
        :class="(scrollTopPosition > 500 ? 'showScrollTopButton' : '')"
        @click.prevent="scrollToTop"
        href="#">
      <span
          style="font-size: 36px"
          class="material-icons">
expand_less
</span>
    </a>
  </div>
</template>

<script>
export default {
  name: "Loader",
  data() {
    return {
      scrollTopPosition: 0,
    }
  },
  methods: {
    onScroll(e) {
      this.scrollTopPosition = e.target.documentElement.scrollTop;
    },
    scrollToTop() {
      window.scrollTo({top: 0, behavior: 'smooth'});
    }
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
}
</script>

<style scoped>
.scrollToTopLink {
  width: 50px;
  height: 50px;
  background-color: #02bd0f;
  color: #fff;
  position: fixed;
  right: 0;
  bottom: -100px;
  text-align: center;
  border-radius: 50px;
  font-weight: bold;
  padding: 6px 0;
  box-shadow: 0px 2px 8px 5px #ccc;
  transition: all 0.3s;
}

.scrollToTopLink:hover {
  background-color: #017806;
}

.showScrollTopButton {
  bottom: 15px;
}
</style>